import api from '../api';
class guildsService {
    getMyGuilds() {
        return api.get('/guilds/my');
    }
    getAllGuilds(name) {
        return api.get(`/guilds/pages?filter=${name}`);
    }
    getMembers(id) {
        return api.get(`/guilds/${id}/members`);
    }
    createGuild(data) {
        return api.post('/guilds', data);
    }
    editGuild(id, data) {
        return api.patch(`/guilds/${id}`, data);
    }
    checkName(name, id) {
        return api.post(`/guilds/check-name`, { name, id });
    }
    joinGuild(id) {
        return api.get(`/guilds/${id}/join`);
    }
    requestGuild(id) {
        return api.get(`/guilds/${id}/request`);
    }
    leaveGuild(id) {
        return api.get(`/guilds/${id}/leave`);
    }
    deleteGuild(id) {
        return api.post(`/guilds/${id}/delete`);
    }
    getOneGuild(id) {
        return api.get(`/guilds/${id}`);
    }
    makeAdmin(attr) {
        return api.get(`/guilds/${attr.guildId}/make-admin/${attr.userId}`);
    }
    revokeAdmin(attr) {
        return api.get(`/guilds/${attr.guildId}/revoke-admin/${attr.userId}`);
    }
    deleteUserFromGuildAction(attr) {
        return api.get(`/guilds/${attr.guildId}/delete/${attr.userId}`);
    }
    banUser(guildId, data) {
        return api.post(`/guilds/${guildId}/ban`, data);
    }
    activateUser(guildId, data) {
        return api.post(`/guilds/${guildId}/activate`, data);
    }
    makeNewOwner(data) {
        return api.get(`guilds/${data.guildId}/leave-owner/${data.nextOwnerId}`);
    }
    getRequests(guildId) {
        return api.get(`/guilds/${guildId}/requests`);
    }
    acceptRequest(data) {
        return api.get(`/guilds/${data.guildId}/accept/${data.requestId}`);
    }
    declineRequest(data) {
        return api.get(`/guilds/${data.guildId}/decline/${data.requestId}`);
    }
    uploadGuildImage(data) {
        return api.post(`/guilds/${data.guildId}/image`, data.formData);
    }
    deleteRequestGuild(guildId) {
        return api.delete(`/guilds/request/${guildId}`);
    }
}
export default new guildsService();
